import React from "react";
import clsx from "clsx";
import { formatGroupedPrice } from "../../utils/currencyDisplay";

interface RollingDigitProps {
  value: string;
}

const RollingDigit: React.FC<RollingDigitProps> = ({ value }) => {
    const digit = Number.parseInt(value, 10);

    if (Number.isNaN(digit)) {
        return (
            <span
                className={clsx(
                    "inline-flex items-center justify-center leading-none",
                    value === "," ? "w-[0.28em]" : "w-[0.35em]",
                )}
            >
                {value}
            </span>
        );
    }

    return (
        <div className="relative h-[1em] w-[0.65em] overflow-hidden inline-block align-bottom">
            <div
                className="transition-transform duration-700 absolute left-0 top-0 flex flex-col items-center w-full"
                style={{
                    transform: `translateY(-${digit * 10}%)`,
                    transitionTimingFunction: "cubic-bezier(0.34, 1.56, 0.64, 1)",
                }}
            >
                {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
                    <div
                        key={num}
                        className="h-[1em] w-full flex items-center justify-center"
                    >
                        {num}
                    </div>
                ))}
            </div>
        </div>
    );
};

interface RollingPriceProps {
  price: number;
  className?: string;
}

const RollingPrice: React.FC<RollingPriceProps> = ({ price, className }) => {
    const priceStr = formatGroupedPrice(price);
    const chars = priceStr.split("");

    return (
        <div
            className={clsx(
                "inline-flex items-center overflow-hidden h-[1em] leading-none tabular-nums",
                className,
            )}
        >
            {chars.map((char, index) => {
                const keyFromRight = chars.length - 1 - index;
                return <RollingDigit key={keyFromRight} value={char} />;
            })}
        </div>
    );
};

export default RollingPrice;
